import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { AuthService } from '../../services/AuthService';
import useRequest from '../../hooks/useRequest';
import { isMobile } from '../../helpers/Mobile';

import LoginHeader from '../../components/atoms/LoginHeader';
import FooterMobile from '../../components/atoms/FooterMobile';
import GradientButton from '../../components/atoms/GradientButton';

import './styles.scss';

const ConfirmAccountView = (props) => {
    const history = useHistory();
    const { token } = useParams();

    useEffect(() => {
        console.log(token);
        AuthService.confirm(token)
            .then(data => {
                showSuccess('Usuario confirmado');
                console.log('confirmar');
            }).catch((error) => {
                dealWithError(error, 'Error al confirmar usuario');
            });
    }, []);

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();

        history.push('/login');
    }

    return (
        <div className="confirm-account-container">
            <LoginHeader></LoginHeader>

            <div className="confirm-account-content">
                <form className="confirm-account-form" onSubmit={handleSubmit}>
                    {(success === false && message) && <>
                        <h1 className="confirm-account-title">Tu cuenta no ha podido ser confirmada</h1>
                        <h2 className="confirm-account-subtitle">{message}</h2>
                        </>
                    }
                    {(success === true && message) &&
                        <h1 className="confirm-account-title">Tu cuenta ha sido confirmada</h1>
                        &&
                        <h2 className="confirm-account-subtitle">Ya podés ingresar a la Oficina Virtual</h2>
                    }
                    <div className="confirm-account-button">
                        <GradientButton legend={'INGRESAR'} disabled={submitted}
                            handleClick={handleSubmit} type={'submit'} />
                    </div>
                </form>
            </div>
            {isMobile && <FooterMobile></FooterMobile>}
        </div>
    );
}

export default withTranslation()(ConfirmAccountView);